// extracted by mini-css-extract-plugin
export var black = "#000";
export var brightOrange = "#f2994a";
export var deepBlue = "#272f39";
export var grey = "#e0e0e0";
export var lightBlue = "#89b7d7";
export var lightGrey = "#f2f1f1";
export var tangerine = "#f15b29";
export var white = "#fff";